import { render, staticRenderFns } from "./shopping.vue?vue&type=template&id=cfaae780&scoped=true&"
import script from "./shopping.vue?vue&type=script&lang=js&"
export * from "./shopping.vue?vue&type=script&lang=js&"
import style0 from "./shopping.vue?vue&type=style&index=0&id=cfaae780&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfaae780",
  null
  
)

export default component.exports